import {
  SCROLL_TO_RESULTADO_ID,
  ScrollableFieldsConfig,
} from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoAutoScroll'
import { hasAnySim } from '@mchat-rf/consulta-seguimento/utils-consultaSeguimento'
import { SimNaoEnum } from 'components/form'
import { isEmpty } from 'util/checks'

import { ConsultaSeguimentoPergunta06Model } from './model-consultaSeguimentoPergunta06'
import { isPergunta06PegarAllNao } from './utils-consultaSeguimentoPergunta06'

export const PERGUNTA_06_SCROLL_CONFIG: ScrollableFieldsConfig<ConsultaSeguimentoPergunta06Model> = {
  PERGUNTA_06_HEADER: {
    scrollConditions: [
      {
        if: (value) => value === SimNaoEnum.SIM,
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) => value === SimNaoEnum.NAO,
        scrollTo: 'PERGUNTA_06_PEGAR',
      },
    ],
  },
  PERGUNTA_06_PEGAR: {
    scrollConditions: [
      {
        if: (value) => isPergunta06PegarAllNao(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) => hasAnySim(value),
        scrollTo: 'PERGUNTA_06_APONTAR_PARA',
      },
    ],
    isList: true,
    dependsOn: 'PERGUNTA_06_HEADER',
  },
  PERGUNTA_06_APONTAR_PARA: {
    scrollConditions: [
      {
        if: (value) => !isEmpty(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
    dependsOn: 'PERGUNTA_06_PEGAR',
  },
}
